import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";
import {
  syncGenarateToken,
  syncRecord,
} from "../services/SsoService";
import SyncFromChart from "../components/modals/front/SyncFromChart";
import axios from "axios";
import { toast } from "react-toastify";

const ChartSsoContext = createContext();

export const ChartSsoProvider = ({ children }) => {
  const [syncDataModalOpen, setSyncDataModalOpen] = useState(false);
  const [syncingLoader, setSyncingLoader] = useState(false);
  const [syncingStep, setSyncingStep] = useState({ step: "1", message: null });
  const [details, setDetails] = useState({});
  const [selectedSite, setSelectedSite] = useState("nineBoxNow");

  const token_ = localStorage.getItem("auth_token");

  // SSO Syncing
  const getGenarateSyncRecord = async (syncRecordData) => {
    try {
      const res = await syncRecord({
        type: "user",
        userId: syncRecordData?.userId,
        id: syncRecordData?.id,
        code: syncRecordData?.code,
      });
      if (res?.status === 200) {
        // getProfileDetails();
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      toast.error("Somthing went wrong !!!");
    }
  };

  const companyCreateVerify = useCallback(
    async (url, headersToken, selectedsite) => {
      const data = {};
      try {
        const result = await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${headersToken}`,
            "Content-Type": "application/json",
          },
        });
        if (result?.data?.status === 200) {
          setSyncingLoader(false);
          setSyncingStep({
            step: "1",
            message: "Company syncing successfull",
            status: 200,
            selectedWebsite: selectedsite,
          });
          const syncRecordData = {
            id: result?.data?.data?.primaryId,
            userId: result?.data?.data?.userId,
            code: selectedsite,
          };
          getGenarateSyncRecord(syncRecordData);
          if (result?.data) {
            setTimeout(() => {
              setSyncingStep({
                step: "2",
                message: null,
                selectedWebsite: selectedsite,
              });
            }, 2000);
          }
        } else if (result?.data?.status === 417) {
          setSyncingLoader(false);
          setSyncingStep({
            step: "2",
            message: "Company Already Exists",
            status: 417,
            selectedWebsite: selectedsite,
          });
          if (result?.data?._id && result?.data?.email) {
            setTimeout(() => {
              setSyncingStep({
                step: "2",
                message: null,
                selectedWebsite: selectedsite,
              });
            }, 1000);
          }
        } else {
          setSyncingLoader(false);
          setSyncingStep({
            step: "1",
            message:
              result?.data?.message ||
              "An error occurred while processing the request.",
            status: 400,
            selectedWebsite: selectedsite,
          });
          setTimeout(() => {
            setSyncDataModalOpen(false);
            toast.error(
              "Please click on the 9box now button to re-syncing the company"
            );
          }, 1000);
        }
      } catch (err) {
        setSyncingLoader(false);
        setSyncingStep({
          step: "1",
          message:
            err?.response?.data?.message ||
            "An error occurred while processing the request.",
          status: 400,
        });
        setTimeout(() => {
          setSyncDataModalOpen(false);
          toast.error(
            "Please click on the 9box now button to re-syncing the company"
          );
        }, 1000);
      }
    },
    []
  );

  const getGenarateToken = async (DOMAIN, API_URL = "") => {
    setSyncingLoader(true);
    setSyncDataModalOpen(true);
    setSyncingStep({ step: "1", message: null });
    try {
      const res = await syncGenarateToken({
        domain: DOMAIN,
      });
      if (res?.status === 200) {
        const url = API_URL + "verify/token";
        const headersToken = res?.data;
        companyCreateVerify(url, headersToken, selectedSite);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
        setSyncDataModalOpen(false);
      }
    } catch (err) {
      console.log(err);
      setSyncingLoader(false);
      toast.error("Somthing went wrong !!!");
      setSyncDataModalOpen(false);
    }
  };

  return (
    <ChartSsoContext.Provider
      value={{
        syncDataModalOpen,
        setSyncDataModalOpen,
        syncingLoader,
        setSyncingLoader,
        syncingStep,
        setSyncingStep,
        details,
        setDetails,
        selectedSite,
        setSelectedSite,
        getGenarateToken
      }}
    >
      {children}
      {syncDataModalOpen && (
        <>
          <SyncFromChart
            isOpen={syncDataModalOpen}
            setIsOpen={setSyncDataModalOpen}
            details={details}
            selectedSite={selectedSite}
            setSelectedSite={setSelectedSite}
          />
        </>
      )}
    </ChartSsoContext.Provider>
  );
};

export const useSsoChart = () => {
  return useContext(ChartSsoContext);
};
